import Modal from "antd/lib/modal/Modal";
import Image from "grandus-lib/components-atomic/image/Image";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

import styles from "components/_others/ageVerificationModal/index.module.scss";
import { get } from "lodash";
import { Button } from "antd";

const SESSION_NAME = 'age_confirmed';

const AgeVerification = () => {
  const { webInstance } = useWebInstance();
  const [modalVisible, setModalVisible] = React.useState(false);

  const handleModalShow = () => {
    if (get(window, 'sessionStorage') && window.sessionStorage.getItem(SESSION_NAME) != 'true') {
        setModalVisible(true);
    }
  };

  // add focus event listener to avoid modal close or remove from DOM when district was not selected
  React.useEffect(() => {
    window.addEventListener("focus", handleModalShow());

    return () => {
      window.removeEventListener("focus", handleModalShow());
    };
  });

  const handleYes = () => {
    setModalVisible(false);
    get(window, 'sessionStorage') && window.sessionStorage.setItem(SESSION_NAME, true);
  };

  return (
    <Modal
      centered
      visible={modalVisible}
      closable={false}
      maskClosable={false}
      className={styles.modal}
      footer={[
        <Button key="yes" type="primary" size="large" onClick={handleYes}>
          Áno, potvrdzujem
        </Button>,
      ]}
    >
      <div className={styles?.body}>
        <Image
          photo={get(webInstance, "logo")}
          size={get(webInstance, "logo.id") + "/200x47"}
          type={"png"}
        />

        <div className={styles?.warning}>Pite s rozumom!</div>
        <div className={styles?.question}>Máte 18 a viac rokov?</div>
      </div>
    </Modal>
  );
};

export default AgeVerification;
